import palette from "../mainPalette";

export default {
	root: {
		color: palette.text.primary,
		"& .MuiInputBase-root:hover": {}
	}
};
